import { defineStore } from 'pinia'
import type { QFooter } from 'quasar'
import { computed, ref, shallowRef } from 'vue'

import configTheme from '@/config/theme.json'

export const useThemeStore = defineStore('theme', () => {
  const pageOffsetTop = ref(0)

  const elPageSearchList = shallowRef<HTMLDivElement | null>(null)
  const elQFooter = shallowRef<InstanceType<typeof QFooter> | null>(null)
  const elListingItemFavoritesBtnBoundingsWidth = ref(0)

  const pageStyleFn = (offset: number) => {
    pageOffsetTop.value = offset

    document.body.style.setProperty('--q-page-offset-top', `${offset}px`)

    return {
      height: offset ? `calc(100vh - ${offset}px)` : '100vh',
    }
  }

  const layoutDrawer = ref<boolean>(false)
  const layoutOverlayLocal = ref<boolean>(false)

  const layoutOverlay = computed({
    get: () => layoutOverlayLocal.value,
    set: (v) => {
      const appNavBarLayoutOverlay =
        configTheme.components.AppNavBar.layoutOverlay

      layoutOverlayLocal.value = appNavBarLayoutOverlay ? v : false
    },
  })

  return {
    elListingItemFavoritesBtnBoundingsWidth,
    elPageSearchList,
    elQFooter,
    layoutDrawer,
    layoutOverlay,
    pageOffsetTop,
    pageStyleFn,
  }
})
